export const CSS_CLASSES = {
  COMMENT_MENTION: 'comment-mention',
} as const
